module.exports = __webpack_public_path__ + "img/banner.0b8692f1.jpg";